import { render, staticRenderFns } from "./publicaciones.vue?vue&type=template&id=8f24db08"
import script from "./publicaciones.vue?vue&type=script&lang=js"
export * from "./publicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports